<gc-text [variant]="'paragraphHeading'">{{
  'signingSummary.customerInformation' | translate
}}</gc-text>
@for (item of customerInformation(); track item.label) {
  <div [class]="'information-item'">
    <gc-text [variant]="'bodyBold'">{{ item.label | translate }}</gc-text>
    <gc-text>{{ item.data }}</gc-text>
  </div>
}
